import { render, staticRenderFns } from "./AlertaLiteratura.vue?vue&type=template&id=d2ae1592&scoped=true"
import script from "./AlertaLiteratura.vue?vue&type=script&lang=js"
export * from "./AlertaLiteratura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ae1592",
  null
  
)

export default component.exports